export default __webpack_public_path__ + "static/media/EBS.5e7cad1b.png";